import userService from "../../services/user.service";
import {
  ActionTypes,
  VideoLibraryDataTableActionTypes,
} from "../Constants/ActionTypes";

export const setVideoLibraryFilterList = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.FILTER_LOADING,
    payload: {
      pageLoading: true,
      buttonLoading: false,
    },
  });
  const { breakdowns } = payload;
  if (breakdowns?.length > 0) {
    userService
      .getAllNewFilter(payload.schoolId)
      .then((res) => {
        const getNewFilterData = res.data.data.newFilterDetailsResponses;
        dispatch({
          type: ActionTypes.SET_VIDEO_LIBRARY_FILTER_LIST,
          payload: getNewFilterData,
        });
      })
      .catch(() => {
        dispatch({
          type: ActionTypes.OPEN_FAIL_DIALOG,
          payload: {
            open: true,
            message: "Something Went Wrong",
          },
        });
        dispatch({
          type: ActionTypes.FILTER_LOADING,
          payload: {
            pageLoading: false,
            buttonLoading: false,
          },
        });
      });
  }
  dispatch({
    type: ActionTypes.FILTER_LOADING,
    payload: {
      pageLoading: false,
      buttonLoading: false,
    },
  });
};

export const deleteFilter = (dispatch, payload) => {
  userService
    .deleteFilterId({ ids: [payload.id] })
    .then((res) => {
      dispatch({
        type: ActionTypes.DELETE_FILTER,
        payload: payload,
      });
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Filter Deleted Successfully.",
            open: true,
          },
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const openAddFilterPopup = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.OPEN_ADD_FILTER_POPUP,
    payload: payload.status,
  });
};

export const addNewFilter = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.FILTER_LOADING,
    payload: {
      pageLoading: false,
      buttonLoading: true,
    },
  });
  userService
    .addFilterPost(
      payload.breakDownName,
      payload.filterName,
      payload.conditionName,
      payload.conditionValue,
      payload.schoolId
    )
    .then((res) => {
      dispatch({
        type: ActionTypes.ADD_NEW_FILTER,
        payload: res.data.data,
      });
      dispatch({
        type: ActionTypes.OPEN_ADD_FILTER_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Filter Added Successfully.",
            open: true,
          },
        },
      });
      dispatch({
        type: ActionTypes.FILTER_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
      dispatch({
        type: ActionTypes.FILTER_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
    });
};

export const updateFilter = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.FILTER_LOADING,
    payload: {
      pageLoading: false,
      buttonLoading: true,
    },
  });
  userService
    .updateFilterPost(
      payload.breakDownName,
      payload.filterName,
      payload.conditionName,
      payload.conditionValue,
      payload.filterId,
      payload.schoolId
    )
    .then((res) => {
      dispatch({
        type: ActionTypes.UPDATE_FILTER,
        payload: res.data.data,
      });
      dispatch({
        type: ActionTypes.FILTER_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
      dispatch({
        type: ActionTypes.OPEN_ADD_FILTER_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Filter Updated Successfully.",
            open: true,
          },
        },
      });
      dispatch({
        type: ActionTypes.SET_EDIT_FILTER,
        payload: false,
      });
      dispatch({
        type: ActionTypes.SET_EDIT_FILTER_INFORMATION,
        payload: null,
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
      dispatch({
        type: ActionTypes.FILTER_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
    });
};

export const setEditFilter = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_EDIT_FILTER,
    payload: payload,
  });
};

export const setEditFilterInformation = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_EDIT_FILTER_INFORMATION,
    payload: payload,
  });
};

export const setAppliedFilterList = (dispatch, payload) => {
  dispatch({
    type: VideoLibraryDataTableActionTypes.APPLIED_FILTER_LIST,
    payload,
  });
};

export const setFilterValues = (dispatch, payload) => {
  dispatch({
    type: VideoLibraryDataTableActionTypes.SET_FILTER_VALUES,
    payload,
  });
};
